// src/components/Auth/PrivateRoute.js - UPDATED (NO ACCESS DENIED MESSAGE)
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from '../UI/LoadingSpinner';

const PrivateRoute = ({ requireAdmin = false }) => {
  const { currentUser, isAdmin, loading } = useAuth();

  // Show loading spinner while checking authentication
  if (loading) {
    return <LoadingSpinner />;
  }

  // Redirect to login if not authenticated
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Check admin access if required
  if (requireAdmin && !isAdmin) {
    // Redirect non-admin users to their dashboard WITHOUT access denied message
    return <Navigate to="/dashboard" replace />;
  }

  // Render child routes
  return <Outlet />;
};

export default PrivateRoute;